module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTIzNS43IDk5NCA3OTcuMiA1MTkuNCAyMzUuNyA0NC44IDIwNiA4MCA3MjUuOSA1MTkuNCAyMDYgOTU4LjhaIiBwLWlkPSIxMDYxIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/toright.svg
// module id = TOoG
// module chunks = 74